<template>
    <div class="kort topspacing" style="margin-top: 55.4px">
        <div class="header" style="height: 55.4px;">
            <div class="left" @click="goBack()">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823; vertical-align: -3px;" xml:space="preserve" width="18px" height="18px">
                    <g>
                        <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179   l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816   C52.942,116.507,52.942,124.327,57.633,129.007z" fill="#FFFFFF"/>
                    </g>
                </svg>
            </div>
            <h1>Kort</h1>
            <div class="right selected-date">
                <span v-if="selectedDate != null || selectedDate != undefined">{{selectedDate | moment}}</span>
                <span v-else>{{today | moment}}</span>
            </div>
        </div>
            
        <mapcomponent></mapcomponent>
    </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import mapcomponent from './../components/MapComponent.vue';

var state = {
  date: ''
}

export default {
    name: 'kort',
    components: {
        mapcomponent,
        Datepicker
    },
    data() {
        return {
            state: state,
            selectedDate: window['selectedDate'],
            today: new Date()
        }
    },
    filters: {
        moment(text) {
            return moment(text).format('DD[.] MMM YYYY');
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    },
    mounted() {
        $(document).foundation();
        $('header').hide();
        var _this = this;

        if (!this.$cookie.get('downloaded')) {
            _this.$router.push({
                name: 'default'
            });
        }
    }
} 

</script>



// WEBPACK FOOTER //
// kort.vue?68a46faa